export default {
  namespaced: true,
  state: {
    // The Profiles currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {},
  },
  getters: {
    find: state => state.active.find(profile => profile.id == Vue.$route.params.id),
  },
  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = {},
        filters = {},
      }
    ) {
      state.search = search
      state.active = items
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
    },
    set(state, profile) {
      state.active = state.active.filter(o => o.id != profile.id)
      profile.location = profile.location || { address: '' }
      state.active.push(profile)
    },
    remove(state, id) {
      state.active = state.active.filter(o => o.id != id)
    },
  },
  actions: {
    search(
      { commit, state },
      {
        search = '',
        page = 1,
        rowsPerPage = 25,
        sortBy = '',
        descending = true,
        filters = {},
      }
    ) {
      this.$authorize('list', 'Profile')

      const params = {
        search: search,
        page: page,
        per: rowsPerPage,
        sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
        ...filters,
      }

      state.loading = true
      return Vue.$http
        .get('admin/profiles', { params })
        .then(response => commit('setActive', response.data), error => (state.loading = false))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Profile')

      return Vue.$http.get(`admin/profiles/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, profile) {
      this.$authorize('create', 'Profile')

      return Vue.$http.post('admin/profiles', { profile }).then(
        response => {
          commit('set', response.data)
          commit(
            'snackbar',
            { text: 'Profile was created successfully', type: 'success' },
            { root: true }
          )
          return response
        },
        error => {
          commit(
            'snackbar',
            { text: 'Profile could not be created', type: 'error' },
            { root: true }
          )
          return Object.assign(profile, error.response.data)
        }
      )
    },
    update({ commit }, profile) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.patch(`admin/profiles/${profile.id}`, { profile }).then(
        response => {
          commit('set', response.data)
          return response
        },
        response => {
          commit('set', Object.assign(profile, response.data))
          throw response
        }
      )
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Profile')

      return Vue.$http.delete(`admin/profiles/${id}`).then(response => commit('remove', id))
    },
    refreshCompletion({ commit }, id) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.get(`admin/profiles/${id}/completion`)
        .then(response => commit('set', response.data))
    },
    regenerateDocument({ dispatch }, id) {
      this.$authorize('regenerate', 'Profile')

      return Vue.$http.patch(`admin/profiles/${id}/regenerate`)
        .then(() => dispatch('fetch', id))
    },
  },
}
